// "Orçamento Indexado" — seleção de fonte pelo método da empresa
// (activeProject.indexedBudgetMethod, servido pelo getDetail; ausente = 'accrual'):
// - 'accrual' (default): motor acumulativo do pipeline -> item.indexed_budget
//   (indexed_balances.budget_indexed)
// - 'global': orçado inteiro × fator -> item.budget_indexed
//   (budgets.value_indexed)

export const itemIndexedBudget = (item, method) =>
  Number.isFinite(method === 'global' ? item?.budget_indexed : item?.indexed_budget)
    ? (method === 'global' ? item.budget_indexed : item.indexed_budget)
    : null

// Valor canônico da OBRA (cards da página de detalhes) — o getDetail já resolve o
// método; o fallback cobre payload antigo durante o rollout.
export const projectIndexedBudget = (activeProject) =>
  Number.isFinite(activeProject?.indexedBudget?.value)
    ? activeProject.indexedBudget.value
    : Number.isFinite(activeProject?.indexedBalance?.budget_indexed)
      ? activeProject.indexedBalance.budget_indexed
      : null

// Indicadores relativos não possuem base de cálculo quando qualquer parcela não é
// finita ou quando o denominador é zero. `null` é o contrato do IndicatorCard para
// exibir "—" sem publicar NaN/Infinity como um valor real.
export const ratioOrNull = (numerator, denominator) =>
  Number.isFinite(numerator) && Number.isFinite(denominator) && denominator !== 0
    ? numerator / denominator
    : null

// Em CUB o "Orçamento Indexado" EXIBE o mesmo valor do Orçado (nominal, a converter
// ÷ índice-base): o invariante garante a igualdade no método global, e no accrual o
// número menor seria lido como distorção quando é inflação congelada pós-freeze. A
// opção continua visível pro cliente — redundante de propósito, nunca divergente
// (decisão Leo 30/07). Converter com checkIfCubBased(v, !cubBased).
export const itemIndexedBudgetDisplay = (item, method, cubBased) =>
  cubBased
    ? (Number.isFinite(item?.budget) ? item.budget : null)
    : itemIndexedBudget(item, method)
